// Per the brand guidelines, with one project-wide decision: Cy Text is used
// everywhere Cy was, because Cy's default glyph set is the "blocky" variant and
// the curvy one isn't reachable from a webfont. Cy Text carries the same voice
// and is legible at the small sizes the ticket stub needs.
//
// Headers use Cy Text at 700/800. Event titles use Canela Deck Bold, which the
// event-card spec calls for at 22pt shrinking to 16pt. Every face is
// self-hosted from /public/fonts — there is no font CDN.

const BODY_STACK = '"Cy Text", ui-sans-serif, system-ui, -apple-system, "Segoe UI", sans-serif';
const DISPLAY_STACK = '"Cy Text", ui-sans-serif, system-ui, -apple-system, sans-serif';
const SERIF_STACK = '"Canela Deck", "Canela", Georgia, "Times New Roman", serif';

export const FONTS = {
  body: BODY_STACK,
  display: DISPLAY_STACK,
  serif: SERIF_STACK,
  condensed: '"Canela Condensed", "Canela", Georgia, serif',
} as const;

const typography = {
  fontFamily: BODY_STACK,
  fontWeightMedium: 600,
  h1: { fontFamily: DISPLAY_STACK, fontWeight: 700, letterSpacing: '-0.01em' },
  h2: { fontFamily: DISPLAY_STACK, fontWeight: 700, letterSpacing: '-0.01em' },
  h3: { fontFamily: SERIF_STACK, fontWeight: 700 },
  h4: { fontFamily: SERIF_STACK, fontWeight: 700 },
  h5: { fontFamily: DISPLAY_STACK, fontWeight: 700 },
  h6: { fontFamily: DISPLAY_STACK, fontWeight: 700 },
  subtitle1: { fontWeight: 700, lineHeight: 1.5 },
  subtitle2: { fontWeight: 600 },
  button: { textTransform: 'none' as const, fontWeight: 600 },
  overline: {
    fontWeight: 700,
    lineHeight: 1.4,
    fontSize: '0.6875rem',
    letterSpacing: '0.1em',
    textTransform: 'uppercase' as const,
  },
};

export default typography;
